import React,{useEffect,useState,useRef} from "react";
import EbgBannerImg from "../../assets/images/EbgBannerImg.png";
import BreadCrumb from "../CommonComponents/BreadCrumb.tsx";
import ImageTextSection from "../CustomComponent/ImageTextSection.tsx";
import styles from "../OurBussiness/InstitutionalBusiness.module.scss";
import aptechAssessmentLogo from "../../assets/images/aptech assessment.png";
import aptechTrainingLogo from "../../assets/images/training solution.png";
import aptechAssesmentEBG from "../../assets/images/AptechAssessmentEBG.png";
import aptechTrainingEBG from "../../assets/images/AptechTrainingEBG.png";
import aptechEICImg from "../../assets/images/aptechEICNew.png";
import { Icon } from "../../assets/Icons.tsx";
import EICLOGO from "../../assets/images/EIC LOGO.svg";
import { motion } from "framer-motion";


const breadcrumb = [
  { title: "Home", link: "/" },
  { title: "Our Businesses", link: "/our-businesses" },
  { title: "Institutional Business", link: "/our-businesses" },
];
const InstitutionalBusiness: React.FC = () => {
  const content = [
    
  `<strong>The Institutional Business (EBG)</strong> of Aptech focuses on providing corporate and institutional clients with customised <strong>corporate training</strong> and <strong>assessment solutions</strong>. Through strategic partnerships with leading government bodies, private organisations, and educational institutions, the EBG team at Aptech enhances workforce capabilities by addressing skill gaps and evaluating talent with the help of tailored programs.`,
  `Training and assessment solutions are delivered through three specialized verticals: `
  ];
  interface DataItem {
    src: string;
    title: string;
    description: string;
    logo?: string;
    contactPerson?: string;
    email?: string;
  }
  const data: DataItem[] = [
    {
      src: aptechAssesmentEBG,
      title: "Aptech Assessment & Testing Solutions ",
      description: `<p>Aptech offers comprehensive testing and assessment services for corporates and institutions to effectively measure competency and performance of employees in organisations. The assessments not only help professionals enhance their skills but also create career growth opportunities, driving both individual and organizational success.</p>
        <p>Aptech Assessment & Testing Solutions (ATTEST) is the market leader in this segment, having conducted millions of tests till date and with a distinguished list of corporate & university customers.</p>`,
      logo: aptechAssessmentLogo,
    },
    {
      src: aptechTrainingEBG,
      title: "Aptech Training Solutions",
      description: `<p>Aptech offers end-to-end training solutions ranging from training needs analysis, content development, trainer certifications, training delivery & post-training support to organisations. The tailored training programs cover content development, training delivery, and follow-up evaluation, all backed by in-depth research for maximum impact and career growth opportunities of employers within and outside the organisations.</p>
        <p>Clients are provided both online and offline training options to accommodate their corporate schedules and preferences. The present clients include leading corporates in the automotive, retail, telecom, hospitality, BFSI, government & academic sectors.</p>`,
      logo: aptechTrainingLogo,
    },
    {
      src: aptechEICImg,
      title: "Education Institutes and Corporates (EIC) Unit",
      logo: EICLOGO,
      description: `<p>The unit provides targeted training programs for government and private education institutes, like schools & colleges. We aim to shape the future of learning and training, aligned with the rapidly changing demands of the education and corporate sectors.</p>
        <p classname="mb-0">Through this unit, Aptech aims to make a significant impact by shaping the future of education and corporate training.</p>`,
      contactPerson: "Sudhakar Vangala",
      email: "sudhakarv@aptech.co.in",
    },
  ];
  const sectionRefs = useRef<(HTMLElement | null)[]>([]);
  const [hasAnimated, setHasAnimated] = useState<boolean[]>(
    data.map(() => false)
  );
  useEffect(() => {
    const observers = sectionRefs.current.map((ref, index) => {
      if (!ref) return null;

      const observer = new IntersectionObserver(
        ([entry]) => {
          // Only animate if scrolling down and it hasn't animated before
          if (entry.isIntersecting && !hasAnimated[index]) {
            setHasAnimated((prev) => {
              const updated = [...prev];
              updated[index] = true;
              return updated;
            });
          }
        },
        { threshold: 0.2, rootMargin: "0px 0px -50px 0px" } // Ensures it's triggered when scrolling down
      );

      observer.observe(ref);
      return observer;
    });

    return () => {
      observers.forEach((observer) => observer?.disconnect());
    };
  }, [hasAnimated]);

  return (
    <div className={styles.institutionalBusiness}>
      <BreadCrumb menu={breadcrumb} />
      <div className="container">
      <motion.div
        initial={{ opacity: 0, y: 100 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, ease: "easeInOut" }}
      >
        <div className={`${styles.banner} section`}>
          <div className="row">
            <div className="col-12">
              <ImageTextSection
                imageSrc={EbgBannerImg}
                imageAlt="EbgBannerImg Image"
                content={content}
                colImageValue={5}
                colTextValue={7}
                heading="Institutional Business (EBG) "
                reverse={true}
                imageAlign="center"
                imageAlignInMob="center"
                imageHeightTablet={`25rem`}
                contentPosition={true}
              />
            </div>
          </div>
        </div>
        </motion.div>

        <div className={styles.EBGData}>
        {data.map((item, index) => {
            return (
              <motion.div
                key={index}
                ref={(el) => (sectionRefs.current[index] = el)}
                initial={{ opacity: 0, y: 100 }}
                animate={hasAnimated[index] ? { opacity: 1, y: 0 } : {}}
                transition={{
                  duration: 1,
                  ease: "easeInOut",
                  delay: index * 0.2,
                }}
                className={`row g-0 justify-content-center ${styles.EbgCardRow}`}
              >
              <div className={`col-lg-2 col-md-12 ${styles.EBGImgDiv}`}>
                <img
                  src={item.src}
                  alt="Aptech Logo"
                  className={`${styles.logoImage} img-fluid`}
                />
              </div>
              <div className="col-lg-10 col-md-12">
                <div
                  className={`d-flex flex-column justify-content-end align-items-start ${styles.EbgDataContent}`}
                >
                  {item.logo && (
                    <img
                      src={item.logo}
                      alt="Aptech Logo"
                      className={`${styles.logo}`}
                    />
                  )}
                  <h6
                    className={`${styles.contentTitle} caps subHeading mb-2 `}
                  >
                    {item.title}
                  </h6>

                  <p
                    className={`${styles.contentDescription} para`}
                    dangerouslySetInnerHTML={{ __html: item.description }}
                  ></p>
                  {(item.email || item.contactPerson) && (
                  <div className={styles.contactBox}>
                  {item.contactPerson && (
                    <p className={`para ${styles.contactPerson}`}>
                      Contact Person: {item.contactPerson}
                    </p>
                  )}
                  {item.email && (
                    <div className={styles.contact}>
                      <Icon name="email" color="var(--primary)" />
                      <div className={`${styles.info} para`}>
                        Email:{" "}
                        <a
                          href={`mailto:${item.email}`}
                          className={styles.link}
                        >
                          {item.email}
                        </a>
                      </div>
                    </div>
                  )}
                  </div>
                  )}
                </div>
              </div>
            </motion.div>
          )
        })}
        </div>
      </div>
    </div>
  );
};

export default InstitutionalBusiness;
